<template>
  <div class="card card-flush" :class="[loading && 'overlay overlay-block']">
    <div class="card-header align-items-center py-5 gap-2 gap-md-5" v-if="filters">
      <slot name="filters"></slot>
    </div>
    <!--begin::Card body-->
    <div class="card-body pt-0">
      <table id="kt_datatable" class="table align-middle table-row-dashed fs-6 gy-5 dataTable no-footer">
        <thead>
        <tr class="fw-bold fs-6 text-muted">
          <th v-for="(cell, i) in headers" :key="i"
              :class="[
                  (cell.text && !cell.width) && 'min-w-125px',
                  cell.width && cell.width,
                  cell.sortable !== false && 'sorting',
                  headers.length - 1 === i && 'text-center'
              ]"
              tabindex="0"
              rowspan="1"
              colspan="1"
              style="cursor: pointer"
          >
            {{ cell.text }}
          </th>
        </tr>
        </thead>
        <tbody class="fw-bold text-gray-600">
        <template v-if="items.length">
          <template v-for="(item, i) in items" :key="i">
            <tr class="odd">
              <template v-for="(cell, j) in headers" :key="j">
                <td class="fs-7" :class="{ 'text-center': headers.length - 1 === j }">
                  <slot :name="`cell.${cell.value}`" :row="item">
                    {{ item[cell.value] }}
                  </slot>
                </td>
              </template>
            </tr>
          </template>
        </template>
        </tbody>
        <tfoot>
        <tr class="fw-bold fs-6 text-muted">
          <th v-for="(header, index) in headers" :class="{ 'text-center': headers.length - 1 === index }">{{ header.text }}</th>
        </tr>
        </tfoot>
      </table>
      <div v-if="loading"
           class="overlay-layer card-rounded bg-dark bg-opacity-5">
        <div class="spinner-border text-primary" role="status">
          <span class="visually-hidden">Aguarde...</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import datatable from "@settings/datatable";

export default {
  data: _ => ({
    datatable: null,
    dateColumn: null,
    dateStart: null,
    dateEnd: null
  }),
  props: {
    loading: {
      required: false,
      type: Boolean,
      default: false,
    },
    filters: {
      required: false,
      type: Object,
      default: false,
    },
    headers: {
      type: Array,
      required: true,
    },
    items: {
      type: Array,
      required: true,
    }
  },

  mounted() {
    this.init()
    const vm = this

    if (this.dateColumn >= 0) {
      $.fn.dataTable.ext.search.push(
          function (settings, row, dataIndex) {
            let date = moment(row[vm.dateColumn], "DD/MM/YYYY")

            return (vm.dateStart === null && vm.dateEnd === null) ||
                (vm.dateStart === null && date <= vm.dateEnd) ||
                (vm.dateStart <= date && vm.dateEnd === null) ||
                (vm.dateStart <= date && date <= vm.dateEnd);
          }
      );
    }

    let searchType = jQuery.fn.DataTable.ext.type.search;

    searchType.string = function ( data ) {
      return ! data ?
          '' :
          typeof data === 'string' ?
              vm.removeAccents( data ) :
              data;
    };

    searchType.html = function ( data ) {
      return ! data ?
          '' :
          typeof data === 'string' ?
              vm.removeAccents( data.replace( /<.*?>/g, '' ) ) :
              data;
    };

    const columnsDefs = this.headers.map((header, index) => {
      return {
        targets: index,
        visible: !header?.hidden,
        searchable: !!header?.searchable,
        orderable: header?.orderable
      }
    })

    this.datatable = $('#kt_datatable').DataTable({
      columns: columnsDefs,
      ...datatable,
    })
  },

  methods: {
    removeAccents ( data ) {
      if ( data.normalize ) {
        return data +' '+ data
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '');
      }

      return data;
    },

    init() {
      this.dateColumn = this.headers.findIndex(header => header.filterType?.includes('interval'))
    },
    resetFilterDates() {
      this.dateStart = null
      this.dateEnd = null
    }
  },
  watch: {
    filters: {
      handler(filters) {
        if (this.$attrs.hasOwnProperty('singleSearch')) {
          // const columns = this.headers.map((header, index) => header?.searchable ? index : null).filter(index => index != null)
          // let search = filters.search.replace(/\s/g, '|')
          //
          // if (search.charAt(search.length - 1) === '|') {
          //   search = search.substring(0, search.length - 1);
          // }

          this.datatable.search(filters.search).draw()
        } else {
          let matchedFilter = Object.entries(filters).filter(filter => !!filter[1])

          if (matchedFilter.length > 0) {
            matchedFilter.forEach(filter => {
              const column = this.headers.findIndex(header => filter[0] === header.value)

              if (this.headers[column].filterType?.includes('interval')) {
                this.dateStart = moment(filter[1].split('-')[0], "DD/MM/YYYY")
                this.dateEnd = moment(filter[1].split('-')[1], "DD/MM/YYYY")

                this.datatable.draw()
              } else {
                this.datatable.columns(column).search(filter[1]).draw()
              }
            })
          } else {
            this.resetFilterDates()
            this.datatable.columns().search('').draw();
          }
        }
      },
      deep: true,
    },
  }
}
</script>
